import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FormDataConsumer, SelectInput, TextInput } from "react-admin";
import { useForm } from "react-final-form";
import { InboundStepsChoices } from "../../../utils/constants";
import { Checklist } from "../../../components/common/Checklist";

const useStyles = makeStyles((theme) => ({
  arrayInput: {
    marginTop: theme.spacing(0),
  },
}));

export const ChecklistForm = ({
  account,
  yardCommodity,
  isDisabled,
  ...props
}) => {
  const form = useForm();
  const classes = useStyles();

  useEffect(() => {
    if (account?.checklists?.items) {
      account.checklists.items = account.checklists?.items.filter(
        (itm) => itm.processName === "Inbound Shipment" && itm.active
      );
    }
  });

  const handleChecklistChange = async (event) => {
    if (event.target.value) {
      debugger;
      const checklist = account.checklists.items.find(
        (itm) => itm.id === event.target.value
      );
      form.change("checklist", checklist.checklistItems);
    } else {
      form.change("checklist", null);
    }
  };

  return (
    <FormDataConsumer>
      {({ formData, disabled = { isDisabled }, ...rest }) => (
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12}>
            <TextInput
              source="instructions"
              label="Special Instructions"
              variant="outlined"
              multiline
              fullWidth
              disabled={!account || isDisabled}
              helperText={false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectInput
              source="checklistId"
              label="Checklist"
              variant="outlined"
              fullWidth
              choices={account?.checklists?.items || []}
              optionText={(choice) => `${choice.name}`}
              optionValue="id"
              helperText={false}
              allowEmpty
              disabled={!account || isDisabled}
              onChange={handleChecklistChange}
            />
          </Grid>
          {
            <Grid item xs={12}>
              <Checklist
                {...props}
                workFlowSteps={InboundStepsChoices}
                source="checklist"
                label="Checklist Items"
                className={classes.arrayInput}
                isDisabled={isDisabled}
              />
            </Grid>
          }
        </Grid>
      )}
    </FormDataConsumer>
  );
};
